<div class="main-container-edit">
    <div class="view-component-title">{{'translate.title'|translateTA}}</div>
    <form [formGroup]="formGroup" class="form-container">
        <div class="tem-field" *ngIf="!massChange">
            <span class="tem-field-label">{{'translate.id.label'|translateTA}} <span class="tem-field-required">*</span></span>
            <input nz-input formControlName="ID" [placeholder]="'translate.id.placeholder'|translateTA">
            <div class="field-error" *ngIf="formGroup.get('ID').touched && formGroup.get('ID').hasError('required')">
                {{'translate.id.error.required'|translateTA}}
            </div>
        </div>

        <div class="tem-field" *ngFor="let item of languages">
            <span class="tem-field-label">{{item.name}} <span class="tem-field-required">*</span></span>
            <nz-input-group [nzSuffix]="item.col!=='PTBR' ? translateSuffix : null">
                <input nz-input [formControlName]="item.col" [placeholder]="item.name">
            </nz-input-group>
            <ng-template #translateSuffix>
                <nz-spin nzSimple nzSize="small" *ngIf="translating[item.col]"></nz-spin>
                <button type="button" nz-button nzType="text" nzSize="small" nzShape="circle"
                    *ngIf="!translating[item.col]"
                    nz-tooltip [nzTooltipTitle]="'actions.ia'|translateTA"
                    (click)="translateData($event,item)">
                    <span nz-icon nzType="robot"></span>
                </button>
            </ng-template>
            <div class="field-error" *ngIf="formGroup.get(item.col).touched && formGroup.get(item.col).hasError('required')">
                {{item.name}} {{'translate.error.required'|translateTA}}
            </div>
        </div>

    </form>
    <actions-buttons [buttonList]="buttonList"></actions-buttons>
</div>
